import type { StorageType } from './types';

import { storageLocal } from './storage';

const asyncStorage = (
  key: string,
  initial = '',
  storageType: StorageType = 'session',
) => {
  const s = storageLocal(key, initial, storageType);

  const write = (v: string) => {
    s.write(v);
    return Promise.resolve(v);
  };
  const read = () => Promise.resolve(s.read());

  return { write, read };
};

/**
 * LocalStorageのfactoryIdを管理する
 */
export const factoryIdStorage = asyncStorage('factoryId', '', 'local');
